import React from "react";
import { MoviesGrid } from "../components/MoviesGrid";

function LandingPages() {
  return <MoviesGrid />;
}

export { LandingPages };
